import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SigninFormLiteComponent } from './signin-form-lite.component';
import { AuthSharedModule } from '../../auth-shared.module';
import { KzTooltipModule } from '../../../../kz-ui/ui/tooltip/kz-tooltip.module';
import { RouterModule } from '@angular/router';
import { KzFormModule } from '../../../../kz-ui/ui/form/kz-form.module';
import { KzIconsModule } from '../../../../kz-ui/ui/icon/kz-icons.module';
import { GtmTrackModule } from "../../../../utils/directives/gtm-track/gtm-track.module";

@NgModule({
  declarations: [
    SigninFormLiteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthSharedModule,
    KzTooltipModule,
    RouterModule,
    KzFormModule,
    KzIconsModule,
    GtmTrackModule,
  ],
  exports: [
    SigninFormLiteComponent
  ],
  providers: []
})
export class SigninFormLiteModule {}
